module.exports = __webpack_public_path__ + "img/2_65.02e6f5d9.png";